export default __webpack_public_path__ + "static/media/Main_2.bbf13c0c.jpg";